import React, { useState } from "react";
import MyImage from "../images/myimage.jpg";
import { FaLightbulb } from "react-icons/fa";
import { PiSuitcaseSimpleBold } from "react-icons/pi";
import { BiSupport } from "react-icons/bi";
import { FiDownloadCloud } from "react-icons/fi";
import { VscProject } from "react-icons/vsc";
import { FiCoffee } from "react-icons/fi";
import { FiUsers } from "react-icons/fi";
import { GiContract } from "react-icons/gi";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

const About = () => {
  const [counterOn, setCounterOn] = useState(false);
  const [animationOn, setAnimationOn] = useState(false);

  return (
    <>
      <div className="about" id="about">
        <h1 className="mainHeading">ABOUT ME</h1>
        <p className="mainPara">My Introduction</p>
        <div className="aboutContent">
          <div className="aboutRight">
            <ScrollTrigger
              onEnter={() => setAnimationOn(true)}
              onExit={() => setAnimationOn(false)}
            >
              {animationOn && (
                <img
                  className="animate__animated animate__fadeInLeft"
                  src={MyImage}
                  alt=""
                />
              )}
            </ScrollTrigger>
          </div>
          <div className="aboutLeft">
            <ScrollTrigger
              onEnter={() => setAnimationOn(true)}
              onExit={() => setAnimationOn(false)}
            >
              {animationOn && (
                <div className="aboutTabs animate__animated animate__fadeInRight">
                  <div className="aboutTab">
                    <FaLightbulb className="tabIcon" />
                    <h5 className="tabHeading">Experience</h5>
                    <p className="tabPara">2+ Years</p>
                  </div>
                  <div className="aboutTab">
                    <PiSuitcaseSimpleBold className="tabIcon" />
                    <h5 className="tabHeading">Completed</h5>
                    <p className="tabPara">50+ Projects</p>
                  </div>
                  <div className="aboutTab">
                    <BiSupport className="tabIcon" />
                    <h5 className="tabHeading">Support</h5>
                    <p className="tabPara">Online 24/7</p>
                  </div>
                </div>
              )}
            </ScrollTrigger>
            <ScrollTrigger
              onEnter={() => setAnimationOn(true)}
              onExit={() => setAnimationOn(false)}
            >
              {animationOn && (
                <p className="aboutPara animate__animated animate__fadeInUp">
                  I'm a frontend and backend website developer, I create web
                  applications and web pages with UI/UX. I have years of
                  experience and many clients are satisfied with the projects
                  carried out
                </p>
              )}
            </ScrollTrigger>
            <ScrollTrigger
              onEnter={() => setAnimationOn(true)}
              onExit={() => setAnimationOn(false)}
            >
              {animationOn && (
                <a href='Resume.pdf' download="Resume.pdf">
                  <button className="mainBtn aboutBtn animate__animated animate__fadeInUp">
                    Get Resume
                    <FiDownloadCloud className="btnIcon" />
                  </button>
                </a>
              )}
            </ScrollTrigger>
          </div>
        </div>

        <ScrollTrigger
          onEnter={() => setAnimationOn(true)}
          onExit={() => setAnimationOn(false)}
        >
          {animationOn && (
            <div className="serves animate__animated animate__fadeInUp">
              <div className="serve">
                <VscProject className="serveIcon" />
                <ScrollTrigger
                  onEnter={() => setCounterOn(true)}
                  onExit={() => setCounterOn(false)}
                >
                  <h4>
                    {counterOn && (
                      <CountUp start={0} end={50} duration={3} delay={0} />
                    )}
                  </h4>
                </ScrollTrigger>
                <p>Project Completed</p>
              </div>
              <div className="serve">
                <FiCoffee className="serveIcon" />
                <h4>
                  {counterOn && (
                    <CountUp start={0} end={100} duration={3} delay={0} />
                  )}
                </h4>
                <p>Cup of Coffee</p>
              </div>
              <div className="serve">
                <FiUsers className="serveIcon" />
                <h4>
                  {counterOn && (
                    <CountUp start={0} end={30} duration={3} delay={0} />
                  )}
                </h4>
                <p>Satisfied Client</p>
              </div>
              <div className="serve">
                <GiContract className="serveIcon" />
                <h4>
                  {counterOn && (
                    <CountUp start={0} end={5} duration={3} delay={0} />
                  )}
                </h4>
                <p>Contracts</p>
              </div>
            </div>
          )}
        </ScrollTrigger>
      </div>
    </>
  );
};

export default About;
